module.exports = __webpack_public_path__ + "img/arrow-ios-right.e5401fe8.svg";